import React from 'react';
import {
  StyledSelectionBoxLabel,
  StyledSelectionBoxContainer,
  StyledDetailLabel,
  StyledIconContainer,
  HiddenRadioButton,
  StyledSelect,
  StyledTextContainer,
} from './styled';

export interface SelectionBoxProps {
  title: string;
  detail?: string;
  icon?: React.ReactNode;
  value?: any;
  selected?: boolean;
  onChange: (arg: any) => void;
  disabled?: boolean;
  selectedText?: string;
}

export const SelectionBox: React.FC<SelectionBoxProps> = ({
  title,
  detail,
  disabled,
  icon,
  onChange,
  value,
  selected,
  selectedText,
}) => (
  <StyledSelectionBoxContainer disabled={disabled} selected={selected}>
    <HiddenRadioButton
      disabled={disabled}
      checked={selected === true}
      onChange={() => onChange(value)}
    />
    <StyledIconContainer disabled={disabled} selected={selected}>
      {icon}
    </StyledIconContainer>
    <StyledTextContainer>
      <StyledSelectionBoxLabel selected={selected}>
        {title}
      </StyledSelectionBoxLabel>
      <StyledDetailLabel selected={selected}>{detail}</StyledDetailLabel>
      <StyledSelect>{selectedText}</StyledSelect>
    </StyledTextContainer>
  </StyledSelectionBoxContainer>
);
